module.exports = __webpack_public_path__ + "img/ceratostigma-plumbaginoides.655cbf32.jpg";